export const urlSafeBase64Encode = (str = '') => {
  return btoa(JSON.stringify(str)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '.');
};

export const urlSafeBase64Decode = (str = '') => {
  try {
    return JSON.parse(atob(str.replace(/-/g, '+').replace(/_/g, '/').replace(/\./g, '=')));
  } catch {
    return {};
  }
};
